import FiberManualRecord from '@mui/icons-material/FiberManualRecord';
import IconButton from '@mui/material/IconButton';
import { styled, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

type Props = {
  theme: Theme;
};

export const SocialIconButton = styled(IconButton)(({ theme }: Props) => ({
  '&:after': {
    display: 'none',
  },
  color: theme.palette.text.secondary,
})) as typeof IconButton;

export const FiberIcon = styled(FiberManualRecord)(({ theme }: Props) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.5rem',
  minWidth: '24px',
  paddingRight: '0.5rem',
}));

export const SubHeader = styled(Typography)(({ theme }: Props) => ({
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
})) as typeof Typography;
